<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Report</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Loyalty Point System</b>
      /
      <router-link to="/lps/report/view/vendor">Report</router-link>
      /
      <b>Overall Report</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
      <div
        class="col-12 col-lg-6 col-sm-12 d-flex flex-column flex-sm-row align-items-center"
      >
        <span class="m-auto"></span>
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Card -->
        <div class="card text-left">
          <div class="card-body">
            <div id="active" class="">
              <h4 class="card-title mb-3">
                <b>{{ title }}</b>
              </h4>
              <!-- Active -->
              <div class="table-responsive">
                <table
                  id="payout_tbl"
                  class="display table table-striped table-bordered"
                  style="width:100%; text-align: center;"
                >
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Month</th>
                      <th>Year</th>
                      <th>Total earn</th>
                      <th>Invoice</th>
                      <th>Status</th>
                      <th>Payment Voucher</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(list, index) in lists" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ convertMonth(list.month) }}</td>
                      <td>{{ list.year }}</td>
                      <td>$ {{ list.total }}</td>
                      <td>{{ checkInvoice(list.invoice_url) }}</td>
                      <td>{{ checkCashed(list.cashed) }}</td>
                      <td>{{ list.payment_voucher }}</td>
                      <td>
                        <router-link
                          :to="redirect(list.entity_id, list.month, list.year)"
                          class="btn btn-primary btn-rounded btn-block"
                        >
                          View Details
                        </router-link>
                        <input
                          type="button"
                          v-if="list.cashed != 0"
                          to="/"
                          class="btn btn-secondary btn-rounded btn-block"
                          value="Pay"
                          disabled
                        />
                        <input
                          type="button"
                          v-else
                          to="/"
                          class="btn btn-success btn-rounded btn-block"
                          value="Pay"
                          @click="goTo(list.id)"
                        />
                        <input
                          type="button"
                          v-if="list.invoice_url == null"
                          to="/"
                          class="btn btn-secondary btn-rounded btn-block"
                          value="View Invoice"
                          disabled
                        />
                        <input
                          type="button"
                          @click="viewInvoice(list.id)"
                          v-else
                          to="/"
                          class="btn btn-primary btn-rounded btn-block"
                          value="View Invoice"
                        />
                        <!-- @click="clickPay(list, list.id)" -->
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "report-update",
  components: {},

  data() {
    return {
      lists: [],
      title: ""
    };
  },

  methods: {
    async loadDetails() {
      if (this.checkToken() == false) {
        swal({
          icon: "error",
          text: "You are not authorised"
        });
        return;
      }

      try {
        let id = this.$route.params.id;
        let result = await axios.get(axios.lpsURL + "/payout/vendor/" + id, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          }
        });
        this.lists = result.data.payouts;
      } catch (error) {
        console.log(error);
      }
    },

    clickPay(list, id) {
      if (this.checkToken() == false) {
        swal({
          icon: "error",
          text: "You are not authorised"
        });
        return;
      }
      swal({
        icon: "warning",
        text: "Are you sure?",
        buttons: ["Cancel", "Yes"]
      }).then(confirm => {
        if (!confirm) {
          return;
        }
        axios
          .post(
            axios.lpsURL + "/api/payout/update",
            {
              id: id
            },
            {
              headers: {
                Authorization: "Bearer " + this.checkToken()
              }
            }
          )
          .then(res => {
            if (res.data.success != true) {
              swal({
                icon: "error",
                text: "Failed to update status"
              });
              return;
            }

            swal({
              icon: "success",
              text: "Successfully Updated"
            });
            list.cashed = 1;
            return;
          });
      });
    },

    checkToken() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token == null) {
        return false;
      }
      token = JSON.parse(token);
      token = token.access_token;

      return token;
    },

    async loadData() {
      await this.loadDetails();
      this.createDatatable();
    },

    destroyDatatable() {
      $("#payout_tbl")
        .DataTable()
        .destroy();
    },

    createDatatable() {
      $("#payout_tbl").DataTable({
        pageLength: 5,
        dom: "Bfrtip",
        buttons: ["excel", "pdf"]
      });
    },

    convertMonth(int) {
      switch (int) {
        case 1:
          return "January";
        case 2:
          return "February";
        case 3:
          return "March";
        case 4:
          return "April";
        case 5:
          return "May";
        case 6:
          return "June";
        case 7:
          return "July";
        case 8:
          return "August";
        case 9:
          return "September";
        case 10:
          return "October";
        case 11:
          return "November";
        case 12:
          return "December";
      }
    },

    checkInvoice(str) {
      if (str == null) {
        return "N/A";
      }
      return "Completed";
    },

    checkCashed(str) {
      if (str == 0) {
        return "Unpaid";
      }
      return "Paid";
    },

    viewInvoice(id) {
      if (!this.checkToken()) {
        return;
      }
      axios
        .get(axios.lpsURL + "/payout/download/" + id, {
          headers: {
            Authorization: "Bearer " + this.checkToken()
          },
          responseType: "arraybuffer"
        })
        .then(res => {
          let type = "application/pdf";
          let blob = new Blob([res.data], { type: type }),
            url = window.URL.createObjectURL(blob);
          window.open(url);
        });
    },

    goTo(id) {
      this.$router.push("/report/pay/" + id);
    },

    redirect(id, month1, year) {
      let months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      let month = months.indexOf(month1) + 1;

      return "/report/view/" + id + "/" + month1 + "/" + year;
    }
  },

  async created() {
    this.loadData();
  }
};
</script>
